import classnames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import s from './SubHeader.less'
import { selectGeoentityActiveFilter } from '../../store/geoentity/filter.selectors'

const SubHeader = ({ children }) => {
  const selectedActiveFilter = useSelector(selectGeoentityActiveFilter)

  return <div className={classnames(s.subHeader, selectedActiveFilter && s.borderless)}>{children}</div>
}

export default SubHeader
